import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const POINTS = [
  ["What we collect", "Your account details (name, email, role) and the session information you enter: client names or initials, goals, trial and behavior data, session notes and voice dictations."],
  ["How it's used", "Only to provide the service to you: storing your notes, drafting and polishing SOAP notes, transcribing dictation and charting progress. We do not sell your data or use it for advertising."],
  ["AI processing", "To draft, polish and transcribe notes, the text or audio you submit is sent to third-party AI providers for processing. Audio recordings are not stored after transcription."],
  ["Who can see it", "Your clients and notes are visible only to you. Group owners manage billing and seats but cannot read members' notes."],
  ["Your responsibilities", "Enter only the minimum necessary protected health information. Using client initials instead of full names is recommended. Keep your password private and sign out on shared devices."],
  ["Security", "Passwords are encrypted (hashed), sessions use secure http-only cookies, and repeated failed logins are locked out."],
  ["Your choices", "You can edit or delete any client or note at any time. Contact your organization's administrator to close your account."],
];

export function PrivacyNotice({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto" data-testid="privacy-notice-dialog">
        <DialogHeader><DialogTitle>Privacy notice</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-500">Beyond Boundaries ABA Scribe handles health-related information. Please read how your data is handled.</p>
        <div className="space-y-4 mt-2">
          {POINTS.map(([h, t]) => (
            <div key={h}>
              <h4 className="text-sm font-semibold text-slate-900">{h}</h4>
              <p className="text-sm text-slate-600 leading-relaxed">{t}</p>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
